module.exports = "/_next/static/images/5-573a08fa88b88b5abf49ff7b15951154.png";